<ng-container *ngIf="loading">
  <div class="table-loader-overlay table-overlay-margin">
    <div class="overlay-spinner-container">
      <mat-spinner color="primary" diameter="75"></mat-spinner>
    </div>
  </div>
</ng-container>

<h2 class="page-header">Plaatsingsprijzen IP-borden</h2>
<div class="flex-table" *ngIf="signPlacementPrices != null">
  <div class="flex-header-row">
    <div class="flex-table-cell flex-2">Naam bord</div>
    <div class="flex-table-cell flex-2">Afmetingen</div>
    <div class="flex-table-cell flex-2">Type bord</div>
    <div class="flex-table-cell flex-2">Type plaatsing</div>
    <div class="flex-table-cell flex-1 display-mode">Tijd plaats.</div>
    <div class="flex-table-cell flex-1 display-mode">Tijd afhalen</div>
    <div class="flex-table-cell flex-1 display-mode">Design</div>
    <div class="flex-table-cell flex-1 display-mode">AAA</div>
    <div class="flex-table-cell flex-1 display-mode">AA</div>
    <div class="flex-table-cell flex-1 display-mode">A</div>
    <div class="flex-table-cell flex-1 display-mode">B</div>
    <div class="flex-table-cell flex-1 display-mode">C</div>
    <div class="flex-table-cell flex-1"></div>
  </div>
  <div
    class="flex-table-row"
    *ngFor="let price of signPlacementPrices; index as i"
  >
    <div class="flex-table-cell flex-2">
      <ng-container *ngIf="!price.editing; else editName">
        {{ price.signPlacementPriceType?.label }}
      </ng-container>
      <ng-template #editName>
        <mat-form-field class="full-width" appearance="outline">
          <mat-select
            matInput
            placeholder="Naam bord"
            [(ngModel)]="price.signPlacementPriceType"
            [compareWith]="compareOrdinalEnums"
            (ngModelChange)="signPlacementPriceTypeChanged(price)"
            required
          >
            <mat-option
              *ngFor="let option of SIGN_PLACEMENT_PRICE_TYPE_CHOICES_ARRAY"
              [value]="option"
            >
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </div>
    <div class="flex-table-cell flex-2">
      <ng-container *ngIf="!price.editing; else editMeasurements">
        {{
          price.signMeasurements?.width
            | joiner: ' x ':price.signMeasurements?.height
        }}
      </ng-container>
      <ng-template #editMeasurements>
        <ng-container
          *ngIf="
            price.signPlacementPriceType?.ordinal ===
            SIGN_PLACEMENT_PRICE_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
          "
        >
          <mat-form-field class="full-width" appearance="outline">
            <mat-select
              matInput
              placeholder="Afmetingen"
              [(ngModel)]="price.signMeasurements"
              [compareWith]="compareValueEnums"
              required
            >
              <mat-option
                *ngFor="let option of SIGN_MEASUREMENTS_CHOICES_ARRAY"
                [value]="option"
              >
                {{ option.width | joiner: ' x ':option.height }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-container
          *ngIf="
            price.signPlacementPriceType?.ordinal ===
            SIGN_PLACEMENT_PRICE_TYPE_CHOICES.IP_BOARD.ordinal
          "
        >
          <mat-form-field class="full-width" appearance="outline">
            <mat-select
              matInput
              placeholder="Afmetingen"
              [(ngModel)]="price.signMeasurements"
              [compareWith]="compareValueEnums"
              required
            >
              <mat-option
                *ngFor="let option of IP_BOARD_SIGN_MEASUREMENTS_CHOICES_ARRAY"
                [value]="option"
              >
                {{ option.width | joiner: ' x ':option.height }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </ng-template>
    </div>
    <div class="flex-table-cell flex-2">
      <ng-container *ngIf="!price.editing; else editBoardType">
        {{ price.boardType?.label }}
      </ng-container>
      <ng-template #editBoardType>
        <ng-container
          *ngIf="
            price.signPlacementPriceType?.ordinal ===
            SIGN_PLACEMENT_PRICE_TYPE_CHOICES.IP_BOARD.ordinal
          "
        >
          <mat-form-field class="full-width" appearance="outline">
            <mat-select
              matInput
              placeholder="Type bord"
              [(ngModel)]="price.boardType"
              [compareWith]="compareOrdinalEnums"
              (ngModelChange)="boardTypeChanged(price)"
              required
            >
              <mat-option
                *ngFor="let option of BOARD_TYPE_CHOICE_ARRAY"
                [value]="option"
              >
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </ng-template>
    </div>
    <div class="flex-table-cell flex-2">
      <ng-container *ngIf="!price.editing; else editPlacementType">
        {{ price.placementType?.label }}
      </ng-container>
      <ng-template #editPlacementType>
        <ng-container
          *ngIf="
            price.signPlacementPriceType?.ordinal ===
            SIGN_PLACEMENT_PRICE_TYPE_CHOICES.IP_BOARD.ordinal
          "
        >
          <ng-container
            *ngIf="
              price.boardType?.ordinal ===
                BOARD_TYPE_CHOICES.SINGLE_SIDED.ordinal ||
              price.boardType?.ordinal === BOARD_TYPE_CHOICES.V.ordinal
            "
          >
            <mat-form-field class="full-width" appearance="outline">
              <mat-select
                matInput
                placeholder="Type plaatsing"
                [(ngModel)]="price.placementType"
                [compareWith]="compareOrdinalEnums"
                (ngModelChange)="placementTypeChanged(price)"
                required
              >
                <mat-option
                  *ngFor="let option of PLACEMENT_TYPE_CHOICES_ARRAY"
                  [value]="option"
                >
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container
            *ngIf="
              price.boardType?.ordinal ===
              BOARD_TYPE_CHOICES.DOUBLE_SIDED.ordinal
            "
          >
            <mat-form-field class="full-width" appearance="outline">
              <mat-select
                matInput
                placeholder="Type plaatsing"
                [(ngModel)]="price.placementType"
                [compareWith]="compareOrdinalEnums"
                (ngModelChange)="placementTypeChanged(price)"
                required
              >
                <mat-option
                  *ngFor="let option of DOUBLE_SIDED_PLACEMENT_CHOICES_ARRAY"
                  [value]="option"
                >
                  {{ option.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </ng-container>
      </ng-template>
    </div>
    <div
      class="flex-table-cell flex-1"
      [ngClass]="price.editing ? 'edit-mode' : 'display-mode'"
    >
      <ng-container *ngIf="!price.editing; else editPlacementMinuteBudget">
        <span>{{ price.placementMinuteBudget | or }} min</span>
      </ng-container>
      <ng-template #editPlacementMinuteBudget>
        <mat-form-field appearance="outline">
          <input
            matInput
            type="number"
            [(ngModel)]="price.placementMinuteBudget"
          />
          <div matSuffix>min</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div
      class="flex-table-cell flex-1"
      [ngClass]="price.editing ? 'edit-mode' : 'display-mode'"
    >
      <ng-container *ngIf="!price.editing; else editRepoMinuteBudget">
        <span>{{ price.repoMinuteBudget | or }} min</span>
      </ng-container>
      <ng-template #editRepoMinuteBudget>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="price.repoMinuteBudget" />
          <div matSuffix>min</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div class="flex-table-cell flex-1 display-mode">
      <img
        *ngIf="price.designUrl != null"
        [ngClass]="price.editing ? 'img-margin' : ''"
        width="30px"
        height="30px"
        [src]="price.designUrl"
        (click)="openLightbox(price.designUrl)"
      />
    </div>
    <div class="flex-table-cell flex-1 display-mode">
      <ng-container *ngIf="!price.editing; else editPriceAAA">
        {{ price.priceAAA | asFormatDecimal: true:2 | or }} €
      </ng-container>
      <ng-template #editPriceAAA>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="price.priceAAA" />
          <div matSuffix>€</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div class="flex-table-cell flex-1 display-mode">
      <ng-container *ngIf="!price.editing; else editPriceAA">
        {{ price.priceAA | asFormatDecimal: true:2 | or }} €
      </ng-container>
      <ng-template #editPriceAA>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="price.priceAA" />
          <div matSuffix>€</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div
      class="flex-table-cell flex-1"
      [ngClass]="price.editing ? 'edit-mode' : 'display-mode'"
    >
      <ng-container *ngIf="!price.editing; else editPriceA">
        <span>{{ price.priceA | asFormatDecimal: true:2 | or }} €</span>
      </ng-container>
      <ng-template #editPriceA>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="price.priceA" />
          <div matSuffix>€</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div
      class="flex-table-cell flex-1"
      [ngClass]="price.editing ? 'edit-mode' : 'display-mode'"
    >
      <ng-container *ngIf="!price.editing; else editPriceB">
        <span>{{ price.priceB | asFormatDecimal: true:2 | or }} €</span>
      </ng-container>
      <ng-template #editPriceB>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="price.priceB" />
          <div matSuffix>€</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div
      class="flex-table-cell flex-1"
      [ngClass]="price.editing ? 'edit-mode' : 'display-mode'"
    >
      <ng-container *ngIf="!price.editing; else editPriceC">
        <span>{{ price.priceC | asFormatDecimal: true:2 | or }} €</span>
      </ng-container>
      <ng-template #editPriceC>
        <mat-form-field appearance="outline">
          <input matInput type="number" [(ngModel)]="price.priceC" />
          <div matSuffix>€</div>
        </mat-form-field>
      </ng-template>
    </div>
    <div class="flex-table-cell flex-1">
      <div
        class="d-flex"
        [ngClass]="price.editing ? 'action-button-margin' : ''"
      >
        <ng-container *ngIf="!price.editing; else saveButton">
          <div class="padding-right clickable" (click)="toggleEditing(price)">
            <mat-icon svgIcon="edit"></mat-icon>
          </div>
        </ng-container>
        <ng-template #saveButton>
          <div
            class="padding-right clickable"
            (click)="saveSignPlacementPrice(price, i)"
          >
            <mat-icon class="icon-size">save</mat-icon>
          </div>
        </ng-template>
        <div class="clickable" (click)="deleteSignPlacementPrice(price, i)">
          <mat-icon svgIcon="close"></mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="pull-left clickable" (click)="addSignPlacementPrice()">
    <mat-icon svgIcon="add"></mat-icon>
  </div>
</div>
<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true"
></mat-paginator>
